import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import CodeInfoSection from 'components/CodeInfoSection';
import { Divider, Typography } from 'material-ui';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoComments extends Component {

    render() {
        const { model } = this.props;
        return (
            <CodeInfoSection title='Пояснения к ТН ВЭД ЕАЭС (в ред. от 12.01.2024 г.)'
                expanded={false} action={'comments'} count={model.comments.length}>
                <div>
                    {model.comments.map((comment, index) => (
                        <div key={index} >
                            <Typography component='div' paragraph >
                                <div dangerouslySetInnerHTML={{ __html: comment }}></div>
                            </Typography>
                            {index < model.comments.length - 1 &&
                                <Typography component='div' paragraph >
                                    <Divider />
                                </Typography>
                            }
                        </div>
                    ))}
                </div>
            </CodeInfoSection>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoComments.js